module.exports = __webpack_public_path__ + "static/footer-1ce5a051220ea441cfa3b897b20785e6.svg";